import {
    GET_COUNTRY_LIST_SUCCESS,
    GET_COUNTRY_LIST_FAILED,
    RESET_GET_COUNTRY_LIST,
    LOADING_GET_COUNTRY_LIST,
    NETWORK_ERROR_GET_COUNTRY_LIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetCountryList = () => {
    return { type: RESET_GET_COUNTRY_LIST };
};

const adminGetCountryList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_COUNTRY_LIST });
    await adminServices
        .post("getCountryList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: GET_COUNTRY_LIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: GET_COUNTRY_LIST_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GET_COUNTRY_LIST,
                payload: err
            });
        });
};

export { resetGetCountryList, adminGetCountryList };
